import { useState, useEffect } from 'react';
import { usePostTripConnect } from '../../../../context/postTripConnect/PostTripConnectContext';
import PackagesList from './sections/PackagesList/PackagesList';
import PackageForm from './sections/PackageForm/PackageForm';
import { usePlanAccess } from '../../../../components/gating/PlanGate';

const PackagesTab = ({ showCreateModal, setShowCreateModal }) => {
    const { isLocked } = usePlanAccess('pro');
    const {
        packages,
        packagesLoading: loading,
        fetchPackages,
        createPackage,
        updatePackage,
        deletePackage,
        togglePackageStatus
    } = usePostTripConnect();
    const [editingPkg, setEditingPkg] = useState(null);
    const [viewOnly, setViewOnly] = useState(false);

    const isModalOpen = showCreateModal || !!editingPkg || viewOnly;

    useEffect(() => {
        if (!isLocked) {
            fetchPackages();
        }
    }, [isLocked, fetchPackages]);

    const handleOpenCreate = () => {
        setEditingPkg(null);
        setViewOnly(false);
        if (setShowCreateModal) setShowCreateModal(true);
    };

    const handleCloseModal = () => {
        setEditingPkg(null);
        setViewOnly(false);
        if (setShowCreateModal) setShowCreateModal(false);
    };

    const handleOpenEdit = (pkg) => {
        setEditingPkg(pkg);
        setViewOnly(false);
    };

    const handleOpenView = (pkg) => {
        setEditingPkg(pkg);
        setViewOnly(true);
    };

    const handleSave = async (payload, pkgId) => {
        try {
            if (pkgId) {
                await updatePackage(pkgId, payload);
            } else {
                await createPackage(payload);
            }
            handleCloseModal();
        } catch (error) {
            console.error('Error saving package:', error);
        }
    };

    const handleToggleStatus = async (pkg) => {
        const newStatus = pkg.status === 'published' ? 'draft' : 'published';
        try {
            await togglePackageStatus(pkg._id, newStatus);
        } catch (error) {
            console.error('Failed to change status:', error);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this package?')) return;
        try {
            await deletePackage(id);
        } catch (error) {
            console.error('Failed to delete package:', error);
        }
    };

    if (isModalOpen) {
        return (
            <PackageForm
                editingPkg={editingPkg}
                viewOnly={viewOnly}
                setViewOnly={setViewOnly}
                onClose={handleCloseModal}
                onSave={handleSave}
            />
        );
    }

    return (
        <PackagesList
            packages={packages}
            loading={loading}
            isLocked={isLocked}
            onOpenCreate={handleOpenCreate}
            onView={handleOpenView}
            onEdit={handleOpenEdit}
            onDelete={handleDelete}
            onToggleStatus={handleToggleStatus}
        />
    );
};

export default PackagesTab;
